export class ChangePasswordToken {
  static IChangePasswordRepository = Symbol("IChangePasswordRepository");
  static ChangePasswordUseCase = Symbol("ChangePasswordUseCase");
}
